import React, { useCallback, useMemo } from 'react';
import { Select } from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';
import { INLINE_SELECT_PROPS } from './questionValidationRules.style';
import type { OptionSelectionCount, ValidationOperator } from './questionValidationRules.types';
import { getAvailableOperators } from './questionValidationRules.utils';

interface QuestionValidationOperatorSelectProps {
  operator: ValidationOperator;
  selectionCount: OptionSelectionCount;
  onChange: (newOperator: ValidationOperator) => void;
}

export const QuestionValidationOperatorSelect = React.memo<QuestionValidationOperatorSelectProps>(
  function QuestionValidationOperatorSelect({ operator, selectionCount, onChange }) {
    const { t } = useTranslation('questionnaireTemplate');

    const availableOperators = useMemo(() => getAvailableOperators(selectionCount, t), [selectionCount, t]);

    const handleChange = useCallback(
      (e: React.ChangeEvent<HTMLSelectElement>) => {
        onChange(e.target.value as ValidationOperator);
      },
      [onChange],
    );

    return (
      <Select
        display="inline-block"
        {...INLINE_SELECT_PROPS}
        value={operator}
        onChange={handleChange}
        aria-label="Select validation operator"
      >
        {availableOperators.map(({ value, label }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </Select>
    );
  },
);
